import React, { useState } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { RxCross2 } from "react-icons/rx";
import axios from 'axios';

const AppointmentModal = ({ showModal, setShowModal }) => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    service: "",
    note: "",
  });

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false); // ✅ loading state

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess(false);
    setError("");
    setIsSubmitting(true); // ✅ start loading

    try {
      const response = await axios.post(`${import.meta.env.VITE_API_BASE_URL}/api/appointments`, formData, {
        headers: {
          Accept: "application/json",
        },
      });

      // ✅ Success
      setSuccess(true);
      setFormData({ name: "", mobile: "", service: "", note: "" });
    } catch (error) {
      if (error.response) {
        const message = error.response.data.message || "সাবমিশনে সমস্যা হয়েছে।";
        setError(message);
      } else {
        setError("সার্ভারে সংযোগ ব্যর্থ হয়েছে।");
      }
    } finally {
      setIsSubmitting(false); // ✅ stop loading
    }
  };

  return (
    <AnimatePresence>
      {showModal && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">

          <motion.div initial={{ scale: 0.8 }} animate={{ scale: 1 }} exit={{ scale: 0.8 }} transition={{ duration: 0.3 }} className="bg-white p-6 rounded-lg max-w-md w-full relative">
            <button onClick={() => setShowModal(false)} className="absolute top-2 right-2 text-gray-600 hover:text-red-500 text-xl">
              <RxCross2 />
            </button>

            <h2 className="text-xl font-bold mb-4 text-center">অ্যাপয়েন্টমেন্ট ফর্ম</h2>

            <form onSubmit={handleSubmit} className="space-y-4 mt-4">
              {success && <p className="text-green-600 text-center">সফলভাবে জমা হয়েছে ✅</p>}
              {error && <p className="text-red-600 text-center">{error}</p>}

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">নাম</label>
                <input name="name" type="text" value={formData.name} onChange={handleChange} placeholder="আপনার নাম লিখুন"
                  required className="w-full border border-gray-300 rounded-md px-3 py-2" />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">মোবাইল নম্বর</label>
                <input name="mobile" type="text" value={formData.mobile} onChange={handleChange} placeholder="০১XXXXXXXXX"
                  required className="w-full border border-gray-300 rounded-md px-3 py-2" />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">সেবা (service) নির্বাচন করুন</label>
                <select name="service" value={formData.service} onChange={handleChange} required className="w-full border border-gray-300 rounded-md px-3 py-2">
                  <option value="">একটি নির্বাচন করুন</option>
                  <option value="রিভাইভ টেস্ট">রিভাইভ টেস্ট</option>
                  <option value="স্মার্ট স্কুল">স্মার্ট স্কুল </option>
                  <option value="টিচার্স ট্রেনিং">টিচার্স ট্রেনিং</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">নোট (ঐচ্ছিক)</label>
                <textarea name="note" value={formData.note} onChange={handleChange} placeholder="যেকোনো অতিরিক্ত তথ্য লিখুন..."
                  className="w-full border border-gray-300 rounded-md px-3 py-2"></textarea>
              </div>

              {/* ✅ Submit button with loading */}
              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full py-2 rounded-md font-semibold transition ${
                  isSubmitting
                    ? "bg-[#8fd8f3] text-white cursor-not-allowed"
                    : "bg-[#22BEFF] hover:bg-[#1fa8e1] text-white"
                }`}
              >
                {isSubmitting ? "জমা দিচ্ছে..." : "জমা দিন"}
              </button>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AppointmentModal;
